<template>
    <transition name="alert-box-fade">
      <div class="alert-box">
          <div class="alert-box__content">
              <div class="alert-box__text">
                  <span v-html="$t(alertText)"></span>
              </div>
              <div class="alert-box__actions">
                  <span @click="closeAlert" class="icon-clear"></span>
              </div>
          </div>
      </div>
    </transition>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'alert-box',
        computed: {
            ...mapGetters({
                alertText: 'getAlertMessage'
            })
        },
        methods: {
            closeAlert () {
                this.$store.dispatch('setAlertMessage', null)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .alert-box {
        width: auto;
        top: 80px;
        bottom: auto;
        left: 20px;
        right: 20px;
        border-radius: 4px;
        background: $medium_carmine;
        color: $white;
        padding: 1.25em;
        position: fixed;
        overflow: hidden;
        z-index: 9999;
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        flex-direction: column;

        [class*="desktop"] & {
            max-width: 600px;
            top: auto;
            bottom: 20px;
        }

        &__content {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-between;
            width: 100%;
        }

        &__text {
            text-align: center;
            display: flex;
            flex-direction: column;
            margin-top: 6px;
        }

        &__actions {
            display: flex;
            justify-content: space-between;
        }

        .icon-clear {
            font-size: 2rem;
            margin-left: 0.5rem;
        }
    }

    .alert-box-fade-enter-active, .alert-box-fade-leave-active {
        transition: all 1s ease;
    }

    .alert-box-fade-enter, .alert-box-fade-leave-to {
        opacity: 0;
    }
</style>
